import { render, staticRenderFns } from "./InformativeCalendar.vue?vue&type=template&id=3b581740&"
import script from "./InformativeCalendar.vue?vue&type=script&lang=js&"
export * from "./InformativeCalendar.vue?vue&type=script&lang=js&"
import style0 from "./InformativeCalendar.vue?vue&type=style&index=0&id=3b581740&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports